import styled from 'styled-components';

interface AnimatedCheckProps {
  $primaryColor?: string;
  $backgroundColor?: string;
}

const AnimationContainer = styled('div')<AnimatedCheckProps>`
  height: 250px;
  width: 250px;
  margin: -32px;

  .lines,
  .green-c-1,
  .green-c-2,
  .white-c-1,
  .white-c-2,
  .check-c {
    transform-origin: 50% 50%;
  }

  .white-c-1 {
    transform: scale(0);
    animation: reset 0.6s 0.2s forwards;
    fill: ${(props) => props.$backgroundColor ?? props.theme.colorModalBackground};
  }

  .green-c-1 {
    transform: scale(0);
    opacity: 0.4;
    animation: reset 0.8s forwards;

    fill: ${(props) => props.$primaryColor ?? props.theme.colorSuccess};
  }

  @keyframes reset {
    to {
      transform: initial;
    }
  }

  /* Lines */
  .lines {
    transform: scale(0);
    animation: lines 0.8s 0.4s forwards;
  }

  .lines path {
    fill: ${(props) => props.$primaryColor ?? props.theme.colorSuccess};
  }

  @keyframes lines {
    to {
      transform: scale(1.5);
    }
  }

  /* Second Circles */

  .white-c-2 {
    transform: scale(0);
    animation: reset 0.6s 1s forwards;
    fill: ${(props) => props.$backgroundColor ?? props.theme.colorModalBackground};
  }

  .green-c-2 {
    transform: scale(0);
    opacity: 0.4;
    animation: reset 0.8s 0.8s forwards;

    fill: ${(props) => props.$primaryColor ?? props.theme.colorSuccess};
  }

  /* Check */

  .check-c {
    transform: scale(0);
    animation: check-c 0.3s 0.7s forwards ease-in-out;

    fill: ${(props) => props.$primaryColor ?? props.theme.colorSuccess};
  }

  @keyframes check-c {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    70% {
      transform: scale(1.3);
    }
    100% {
      transform: scale(1);
    }
  }

  .check {
    stroke-dasharray: 250;
    stroke-dashoffset: 250;
    animation: check 0.2s 1s forwards ease-in-out;
  }

  @keyframes check {
    to {
      stroke-dashoffset: 0;
    }
  }
`;

export default function AnimatedCheck({ $primaryColor, $backgroundColor }: AnimatedCheckProps) {
  return (
    <AnimationContainer $primaryColor={$primaryColor} $backgroundColor={$backgroundColor}>
      <svg role='img' version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'>
        <circle className='green-c-1' fill='#6ABF39' cx='500' cy='500' r='496.3' />
        <circle className='white-c-1' fill='#FFFFFF' cx='500' cy='500' r='500.0' />
        <circle className='green-c-2' fill='#6ABF39' cx='500' cy='500' r='496.3' />
        <circle className='white-c-2' fill='#FFFFFF' cx='500' cy='500' r='500.0' />
        <circle className='check-c' fill='#6ABF39' cx='500' cy='500' r='272.4' />
        <clipPath id='lines_mask'>
          <circle className='lines-mask' fill='#FFFFFF' cx='500' cy='500' r='496.3' />
        </clipPath>
        <g clipPath='url(#lines_mask)'>
          <g className='lines'>
            <path
              fill='#6ABF39'
              d='M268.6,261.2l-100.8-104l-10.6,10.6l104,100.8C263.7,266.1,266.1,263.7,268.6,261.2z'
            />
            <path
              fill='#6ABF39'
              d='M167.5,500c0-1.7,0-3.5,0.1-5.2l-144.8-2.3v14.9l144.8-2.3C167.5,503.5,167.5,501.7,167.5,500z'
            />
            <path
              fill='#6ABF39'
              d='M261.2,731.4l-104,100.8l10.6,10.6l100.8-104C266.1,736.3,263.7,733.9,261.2,731.4z'
            />
            <path
              fill='#6ABF39'
              d='M500,832.5c-1.7,0-3.5,0-5.2-0.1l-2.3,144.8h14.9l-2.3-144.8C503.5,832.5,501.7,832.5,500,832.5z'
            />
            <path
              fill='#6ABF39'
              d='M738.8,731.4c-2.4,2.5-4.9,4.9-7.4,7.4l100.8,104l10.6-10.6L738.8,731.4z'
            />
            <path
              fill='#6ABF39'
              d='M832.4,494.8c0,1.7,0.1,3.5,0.1,5.2s0,3.5-0.1,5.2l144.8,2.3v-14.9L832.4,494.8z'
            />
            <path
              fill='#6ABF39'
              d='M738.8,268.6l104-100.8l-10.6-10.6l-100.8,104C733.9,263.7,736.3,266.1,738.8,268.6z'
            />
            <path
              fill='#6ABF39'
              d='M500,167.5c1.7,0,3.5,0,5.2,0.1l2.3-144.8h-14.9l2.3,144.8C496.5,167.5,498.3,167.5,500,167.5z'
            />
          </g>
        </g>
        <polyline
          className='check'
          fill='none'
          stroke='#FFFFFF'
          strokeWidth='30'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeMiterlimit='10'
          points='416.5,520 470.1,573.7 583.9,459.9 '
        />
      </svg>
    </AnimationContainer>
  );
}
